<form #emailForm="ngForm">
  <ng-container *ngIf="gatewayCommissioningStore.state$ | async as state">
    <mat-card class="transfer-installation-container" data-at-provide-email>
      <mat-card-content>
        <div class="content-container">
          <mat-card-title>
            {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DIALOG.HEADER' | translate }}
            <div class="sub-title">
              {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.EMAIL_FORM.SUB_HEADER' | translate }}
            </div>
          </mat-card-title>
          <div
            *ngIf="!state.transferInstallationLoading"
            class="flex flex-col justify-center items-center"
          >
            <mat-form-field mat-input-height-large-label class="email-form-field">
              <mat-label>{{ '+PROFILE.DETAILS.EMAIL' | translate }}</mat-label>
              <input
                gtm="onTextField"
                gtmId="email"
                gtmAction="Email"
                gtmCategory="gatewayCommissioningEmailForm"
                [gtmOn]="['change', 'focus', 'blur']"
                [pattern]="emailPattern"
                type="email"
                name="email"
                [(ngModel)]="email"
                matInput
                data-end-user-email-input
                fieldTextContentTooltip
              />
              <mat-error *ngIf="emailForm.controls['email']?.errors?.pattern">{{
                '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.EMAIL.ERROR.PATTERN' | translate
              }}</mat-error>
            </mat-form-field>
          </div>
          <div
            *ngIf="state.transferInstallationLoading"
            class="flex flex-col justify-start items-center"
          >
            <vi-loader
              [isLoading]="true"
              [message]="'+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.LOADER_TEXT' | translate"
            ></vi-loader>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
        <button
          data-at-cancel-btn
          mat-button
          color="primary"
          (click)="onCancel()"
          gtm="onCancelDialog"
          gtmCategory="transferInstallationDialog"
        >
          {{ 'GENERAL.BUTTON.CANCEL' | translate }}
        </button>
        <button
          [disabled]="!emailForm.valid || !email"
          class="transfer-installation-btn"
          data-at-transfer-btn
          mat-raised-button
          color="primary"
          (click)="sendInvitation()"
          gtm="onConfirm"
          gtmCategory="transferInstallationDialog"
        >
          {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.DIALOG.SEND_INVITATION' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-container>
</form>
